import { useContext, useEffect, useState } from "react";
import { PortalAuthenticationResult } from "../../generated/data-contracts";
import { AvisContext } from "../shared/context/AvisContext";
import { AcceptTermsPage } from "./AcceptTermsPage";
import { AvisLoader } from "../shared/components";

interface IAcceptTermsHocProps {
  children: React.ReactNode;
}

export function AcceptTermsHoc(props: Readonly<IAcceptTermsHocProps>) {
  const { children } = props;
  const [isTermsAccepted, setIsTermsAccepted] = useState<boolean>();
  const { login, ctxUser } = useContext(AvisContext);

  useEffect(() => {
    setIsTermsAccepted(
      ctxUser !== undefined && (ctxUser.isTermsAccepted ?? false),
    );
  }, [ctxUser]);

  const handleTermAcception = (data?: PortalAuthenticationResult) => {
    setIsTermsAccepted(data ? data.isTermsAccepted ?? false : false);
    login(data);
  };

  if (isTermsAccepted === undefined) return <AvisLoader />;

  if (!isTermsAccepted)
    return <AcceptTermsPage onUpdate={handleTermAcception} />;

  return children;
}
